import CrudCustom from '../../../libs/custom/CrudCustom';


let SaldoNeracaTranskripService = new CrudCustom('/saldo-neraca-transkrips');
export default SaldoNeracaTranskripService;
